<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: currentPage.images.oImage1.text,
                            position: 'bottom-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-sushi',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.text"></h1>
                </title-s-chapter>

                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>

                <div class="container-components mt-8">
                    <TitleParagraph
                        :options="{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }" class="flex items-end"
                    >
                        
                        <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `Histoire de la sûreté hydraulique vue de l'ingénierie` 
                                    ),
                                }"
                                class="mr-2" style="position: relative;"
                            />
                        <span
                            class="text-xl lg:text-3xl 2xl:text-4xl"
                            v-html="currentPage.content.sSubTitleOne.text"
                        ></span>
                    </TitleParagraph>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card relative">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                            class="flex items-end"
                        >
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Gestion des crues 2.0'
                                    ),
                                }"
                                class="mr-2" style="position: relative;"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphTwo_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphTwo_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Content
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div class="card">
                        <div class="relative pt-8">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'PKWeir, l’innovation virtuose '
                                    ),
                                }"
                                class="-top-2 right-2"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>

                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content
                                        .sParagraphFour_Content_01.text
                                "
                            ></span>
                            <router-link
                                :to="{
                                    name: 'catalogue',
                                    params: { slug: 'page-034' },
                                }"
                                v-html="
                                    currentPage.content
                                        .sParagraphFour_Content_03.text
                                "
                            ></router-link>
                            <span
                                v-html="
                                    currentPage.content
                                        .sParagraphFour_Content_02.text
                                "
                            >
                            </span>
                            <!-- <Dots
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                }"
                            /> -->
                        </paragraph>
                    </div>
                    <!-- <div class="break-inside-avoid"> -->
                        
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <p
                                class="mt-8 text-xl lg:text-3xl 2xl:text-4xl"
                                v-html="currentPage.content.sSubTitleTwo.text"
                            ></p>
                        </TitleParagraph>
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            
                            <span
                                v-html="
                                    currentPage.content.sParagraphFive_Title
                                        .text
                                "
                            ></span>
                            <div class="relative">
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage2
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage2
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                            <!-- <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'PKWeir, l’innovation virtuose'
                                    ),
                                }"
                                class="top-2 right-2"
                            /> -->
                        </div>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphFive_Content
                                        .text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                        </paragraph>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage3.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage3
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    <!-- </div> -->
                   
                    <!-- <div class="card break-inside-avoid" style="padding-top: 0;"> -->
                        <div>
                            <image-with-descriptions class="eliminate-margin"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage4.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage4
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage4
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <p
                                class="mt-8 text-xl lg:text-3xl 2xl:text-4xl"
                                v-html="currentPage.content.sSubTitleThree.text"
                            ></p>
                        </TitleParagraph>
                        <TitleParagraph
                            :options="{
                                from: 'from-sushi',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphSix_Title.text
                                "
                            >
                            </span>
                        </TitleParagraph>

                        <div class="break-inside-avoid">
                            <paragraph
                                :options="{
                                    color: 'text-nandor',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content
                                            .sParagraphSix_Content.text
                                    "
                                >
                                </span>
                                <Triangles
                                    :options="{
                                        colors: [
                                            '#81C341',
                                            '#B7DD92',
                                            '#cce5a4',
                                        ],
                                        direction: 'bottom',
                                    }"
                                />
                            </paragraph>
                            <div>
                                <image-with-descriptions
                                    :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.oImage5.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.oImage5
                                                    .edf,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                            },
                                        ],
                                    }"
                                />
                            </div>
                        </div>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sParagraphSeven_Content
                                        .text
                                "
                            >
                            </span>
                            <!-- <Square
                                :options="{
                                    from: 'feijoa',
                                    to: 'selective_green',
                                }"
                            /> -->
                        </paragraph>
                    <!-- </div> -->
                  
                    <div class="card">
                        <article-note
                            style="overflow: visible"
                            :options="{
                                verticalcontent:
                                    currentPage.content.sParagraphEight_Title
                                        .text,
                                content:
                                    currentPage.content.sParagraphEight_Quote
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl lg:text-3xl',
                                    content: '',
                                },
                                margin: {},
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage6.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage6.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: currentPage.images.oImage6.text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
</style>
